export function AbideFunctionMapper() {
    let obj = {
        map: map,
        lookup: lookup,
        call: call
    };
    obj.fnMap = [];
    return obj;

    function map(application, group, name, fn)
    {
        if (!obj.fnMap[application]) {
            obj.fnMap[application] = {};
        }
        if (!obj.fnMap[application][group]) {
            obj.fnMap[application][group] = {};
        }
        obj.fnMap[application][group][name] = fn;
    }

    function lookup(application, group, name)
    {
        try
        {
            return obj.fnMap[application][group][name];
        }
        catch (err)
        {
            console.log("Error: abide-function-mapper entry not found.  Error:" + err.message);
        }
    }

    function call(application, group, name, ... args)
    {
        try
        {
            return obj.fnMap[application][group][name](args[0], args[1], args[2], args[3], args[4]);
        }
        catch (err)
        {
            console.log("Error occurred calling abide-function-mapper entry .  Error:" + err.message);
        }
    }
}